import { useState } from 'react'

import { matchSorter } from 'match-sorter'

import { VirtualizedList } from '@subaio/components'
import { Form } from '@subaio/components/src/HookForm'
import { Input } from '@subaio/webapp'

import { Category, type CategoryDefinition } from 'components/Category'

import { categories } from './categories'

export const CategoryList = () => {
	const [results, setResults] = useState<Array<CategoryDefinition>>(categories)
	const [heights, setHeights] = useState<Record<string, number>>({})
	const [isOpenLookup, setIsOpenLookup] = useState<Record<string, boolean>>({})

	return (
		<>
			<Form<{ search: string }>
				render={() => (
					<Input
						name='search'
						label='Search categories'
						placeholder='Search categories by title, ID, description or example'
						showOptionalHint={false}
						isClearable
					/>
				)}
				onSubmit={() => undefined}
				onChange={({ search }) =>
					setResults(
						search?.trim()
							? matchSorter(categories, search.trim(), { keys: ['id', 'title', 'description', 'examples'] })
							: categories,
					)
				}
			/>
			<p role='status'>
				{results.length} of {categories.length} categories
			</p>
			{results.length === 0 && <p>No categories match your search.</p>}
			<VirtualizedList
				data={results}
				elementHeight={({ id }) => heights[id] ?? 50}
				overscan={200}
				overscanElements={1}
				render={(category) => (
					<Category
						key={category.id}
						category={category}
						isOpen={isOpenLookup[category.id] ?? false}
						onToggle={() => setIsOpenLookup((current) => ({ ...current, [category.id]: !current[category.id] }))}
						onResize={(height) =>
							setHeights((current) =>
								current[category.id] === height ? current : { ...current, [category.id]: height },
							)
						}
					/>
				)}
			/>
		</>
	)
}
